import style_inject_es_default from "../../../../../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js";

//#region src/components/divider/divider.module.css
var css_248z = ".divider-module_root__wszrh {\n    --divider-color: var(--mantine-color-gray-1);\n\n    &:where([data-variant='middle']):where([data-orientation='horizontal']) {\n        margin: 0 var(--mantine-spacing-sm);\n    }\n\n    &:where([data-variant='middle']):where([data-orientation='vertical']) {\n        margin: var(--mantine-spacing-xxxs) 0;\n    }\n}\n";
var divider_module_default = { "root": "divider-module_root__wszrh" };
style_inject_es_default(css_248z);

//#endregion
export { divider_module_default as default };